module.exports = __webpack_public_path__ + "static/a-town_logo_dark.7fbe5015.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/a-town_logo_dark.jpg
// module id = 125
// module chunks = 19647912047630 114276838955818